export enum EnumUserType {
    Admin = "Admin",
    Teacher = "Teacher",
    Student = "Student"
}
